import React, { useEffect, useState } from "react"
import { Button } from "reactstrap"
import { get } from "helpers/api_helper"
import { settingsTime } from "./maintenanceForm"
import { searchStage, searchRebuildError } from "./useSearchRebuild"

export default function SearchHistory({ refresh }) {
  const [page, setPage] = useState(1), [retry, setRetry] = useState(0), [read, setRead] = useState({ loading: true })
  useEffect(() => {
    let current = true
    setRead({ loading: true })
    get(`/account-search/history?page=${page}`, { timeout: 5000 }).then(response => {
      const data = response?.data
      if (!Array.isArray(data?.items) || !Number.isSafeInteger(data.totalResults) || data.totalResults < 0) throw new Error("Invalid history")
      if (current) setRead({ data })
    }).catch(() => { if (current) setRead({ error: true }) })
    return () => { current = false }
  }, [page, refresh, retry])
  return <section aria-label="Search rebuild action logs" className="mt-4">
    <div className="system-settings__heading"><h5>Rebuild action logs</h5><Button size="sm" disabled={read.loading} onClick={() => setRetry(value => value + 1)}>Refresh rebuild logs</Button></div>
    {read.loading && <p role="status">Loading rebuild logs…</p>}
    {read.error && <div role="alert"><p>Rebuild logs could not be loaded.</p><Button size="sm" onClick={() => setRetry(value => value + 1)}>Retry rebuild logs</Button></div>}
    {read.data && <>
      {!read.data.items.length && <p className="text-muted">No account search rebuilds have been recorded.</p>}
      {read.data.items.map(item => <article key={item.operationId} className="system-settings__history">
        <div className="system-settings__actions"><strong>{item.actorName || "Administrator"}</strong><span className={item.status === "completed" ? "text-success" : item.status === "failed" ? "text-danger" : "text-muted"}>{({ completed: "Rebuilt and verified", failed: "Rebuild failed", pending: "Pending confirmation" })[item.status] || "Unknown result"}</span></div>
        <p className="mb-1">{item.reason}</p>
        <div>{settingsTime(item.completedAt || item.requestedAt)}</div>
        {item.status === "pending" && <div>{searchStage(item.stage)}</div>}
        {item.status === "failed" && <p className="mb-1">{searchRebuildError(item.message)}</p>}
        {Number.isSafeInteger(item.indexedAccounts) && <div>Accounts indexed: {item.indexedAccounts}</div>}
        <details className="system-settings__technical"><summary>Technical details</summary>
          <div>Request: {item.operationId}</div><div>Requested: {settingsTime(item.requestedAt)}</div>
          {Number.isSafeInteger(item.activation?.taskUid) && <div>Activation task: {item.activation.taskUid}</div>}
          {item.message && <div>Result code: {item.message}</div>}
        </details>
      </article>)}
      {(read.data.totalResults > 10 || page > 1) && <div className="system-settings__actions justify-content-end mt-3">
        <Button size="sm" disabled={page <= 1} onClick={() => setPage(value => value - 1)}>Previous rebuild logs</Button>
        <span>Page {page} of {Math.max(page, Math.ceil(read.data.totalResults / 10))}</span>
        <Button size="sm" disabled={page * 10 >= read.data.totalResults} onClick={() => setPage(value => value + 1)}>Next rebuild logs</Button>
      </div>}
    </>}
  </section>
}
